import { AsyncActionHandler } from 'action-handler';
import { fsc, locale } from 'config';

export default new AsyncActionHandler({
  name: 'initialize_fsc',
  stateProp: 'fsc',
  defaultState: {
    fsc: {
      initialized: false
    }
  },
  handler: () => (_, getState) => {
    const {
      currentUser: { id }
    } = getState().registry;
    window.FSC.init({
      host: fsc.host,
      clientId: fsc.clientId,
      defaultProps: {
        data: {
          locale,
          user_id: id
        }
      }
    });

    return {
      fsc: {
        initialized: true
      }
    };
  },
  reduce(_, { fsc }) {
    return {
      fsc
    };
  }
});
